import api from "./api";

/**
 * Cada método aceita um `config` opcional do axios — usado por callers
 * que precisam passar `signal` de AbortController para cancelar requests
 * em flight (ex.: busca debounced que dispara várias requests em sequência).
 */

export const getPipeline = (config = {}) => api.get("/leads/pipeline", config);

export const listLeads = (params = {}, config = {}) =>
  api.get("/leads", { params, ...config });

export const getLead = (id, config = {}) => api.get(`/leads/${id}`, config);

export const createLead = (data, config = {}) => api.post("/leads", data, config);

export const updateLead = (id, data, config = {}) =>
  api.patch(`/leads/${id}`, data, config);

export const addLeadActivity = (id, data, config = {}) =>
  api.post(`/leads/${id}/activity`, data, config);

export const convertLead = (id, config = {}) =>
  api.post(`/leads/${id}/convert`, undefined, config);

export const deleteLead = (id, config = {}) => api.delete(`/leads/${id}`, config);
